import {AppStartListening} from "../../store";
import {ListenerEffectAPI, PayloadAction, Unsubscribe} from "@reduxjs/toolkit";
import {handleClubChange} from "../clubs/slice";
import {loadClubCaddies, loadReviews, loadStatistics} from "./async_actions";
import {loadClubs} from "../clubs/asyncActions";
import {handleFilterSidePanelOpen} from "./slice";

const postClubChange = async (_: any, listenerApi: ListenerEffectAPI<any, any>) => {
    listenerApi.dispatch(loadClubCaddies())
}

const postSidePanelClosed = async (action: PayloadAction<boolean>, listenerApi: ListenerEffectAPI<any, any>) => {
    if (action.payload) {
        return; // opened the drawer...
    }

    listenerApi.dispatch(loadReviews())
}

const postReviewsLoaded = async (_: any, listenerApi: ListenerEffectAPI<any, any>) => {
    listenerApi.dispatch(loadStatistics())
}

export function setupReviewListeners(startListening: AppStartListening): Unsubscribe {
    const subscriptions: any[] = [
        startListening({
            actionCreator: handleClubChange,
            effect: postClubChange,
        }),
        startListening({
            actionCreator: loadClubs.fulfilled,
            effect: postClubChange,
        }),
        startListening({
            actionCreator: handleFilterSidePanelOpen,
            effect: postSidePanelClosed,
        }),
        startListening({
            actionCreator: loadReviews.fulfilled,
            effect: postReviewsLoaded,
        }),
    ]

    return () => {
        subscriptions.forEach((unsubscribe) => unsubscribe())
    }
}